import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Container,
  LateralEsquerda,
  LateralDireita,
  Form,
  SubmitButton,
  LoginForm,
  DivSelect,
} from './styles';
import saibweb from '../../assets/images/saibweb.png';
import Select from 'react-select';
import saibdirectlogo from '../../assets/images/saibdirect-logo.png';
import { FaSpinner, FaKey } from 'react-icons/fa';
import api from '../../services/api';
import { saveMenuToStorage, login, logOut } from '../../services/auth';
// import { connect } from 'react-redux';
// import { EnviromentVars } from '../../config/env';

export const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    const color = '#e8d9ee';
    const selected = '#bb8ecd';
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? selected
        : isFocused
        ? color
        : undefined,
      color: isDisabled ? '#000' : isSelected,
      cursor: isDisabled ? 'not-allowed' : 'default',
      zIndex: '999',
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? selected
            : color
          : undefined,
      },
    };
  },
  input: (styles) => ({ ...styles }),
  placeholder: (styles) => ({ ...styles }),
};

class Login extends Component {
  state = {
    error: '',
    email: '',
    senha: '',
    loading: false,
    mostrarEmpresas: 'false',
    empresaSelecionada: '',
    empresas: [],
    faseLogin: 1,
    nomeUsuario: '',
  };

  async componentDidMount() {
    logOut();
  }

  limparVariaveis = async (e) => {
    this.setState({
      email: '',
      senha: '',
      loading: false,
      mostrarEmpresas: 'false',
      empresaSelecionada: '',
      empresas: [],
    });
    document.getElementById('email').value = '';
    document.getElementById('senha').value = '';
    document.getElementById('empresa').value = '-1';
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const { email, senha, empresaSelecionada, mostrarEmpresas } = this.state;

    if (!email) {
      this.setState({
        error: 'E-mail não pode ser vazio!',
      });
      return false;
    }

    if (!senha) {
      this.setState({
        error: 'Senha não pode ser vazia!',
      });
      return false;
    }
    if (
      !empresaSelecionada ||
      `${empresaSelecionada.EMP_ID}` === '-1' ||
      !mostrarEmpresas
    ) {
      this.setState({
        error: 'Selecione uma empresa antes de logar.',
      });
      return false;
    }
    this.setState({ loading: true });

    try {
      const retorno = await api.post('/v1/accounts/authenticate', {
        username: email,
        password: senha,
        EMP_ID: empresaSelecionada.EMP_ID,
      });

      const _data = retorno.data;
      //

      // não conseguiu comunicar com o servidor //
      if (!_data || _data.length <= 0) {
        if (!_data.sucess)
          this.setState({
            error: '1.Não foi possível comunicar com o servidor',
          });
      } else {
        // conseguiu comunicar com o servidor //
        if (_data.sucess) {
          const dataLogin = _data.data;
          //
          //
          const sessao = {
            codigoUsuario: dataLogin.USR_ID,
            email: dataLogin.username,
            nomeUsuario: dataLogin.nomeusuario,
            codigoEmpresa: empresaSelecionada.EMP_CODIGO,
            empresaId: dataLogin.EMP_ID,
            empresaCfId: empresaSelecionada.EMC_ID,
            empresaCnpj: empresaSelecionada.EMP_CNPJ,
            empresaRazaoSocial: empresaSelecionada.EMP_NOME,
            empresaNomeFantasia: empresaSelecionada.EMP_FANTASIA,
            empresaSaibWeb: empresaSelecionada.EMP_DESTINO_SAIBWEB,
            token: dataLogin.token,
            // menus: dataLogin.menus,
          };


          login(sessao);
          //
          // await this.carregarMenusModulo(EmpresaObjeto.EMP_ID);
          this.props.history.push('/home');
          // window.location.href = '/home'
          return true;
        } else {
          this.setState({
            error: retorno.data.error.message,
          });
          this.limparVariaveis();
        }
      }
    } catch (err) {

      this.setState({
        error: '2.Não foi possível comunicar com o servidor.',
      });
    }
    this.setState({ loading: false });
  };

  carregarMenusModulo = async (empresaId) => {
    const retorno = await api.get('/v1/menus/' + empresaId);
    //
    if (!retorno) {
      this.setState({ menus: [] });
    } else {
      if (retorno.data && retorno.data.sucess) {
        saveMenuToStorage(retorno.data.data);
      }
    }
  };

  handleEmpresas = (value) => {
    this.setState({ empresaSelecionada: value, error: '' });
  };

  handleUsuarioChange = (e) => {
    var email = e.target.value;
    this.setState({
      email: email.toLowerCase(),
      error: '',
      mostrarEmpresas: 'false',
      empresaSelecionada: '',
    });
  };

  saudacaoLogin = () => {
    const { faseLogin, nomeUsuario } = this.state;
    var stamp = new Date();
    var hours;
    var time;

    hours = stamp.getHours();
    var saudacao = '';
    if (hours >= 0 && hours <= 11) {
      time = 'Bom dia';
    }
    if (hours >= 12 && hours <= 17) {
      time = 'Boa tarde';
    }
    if (hours >= 18 && hours <= 23) {
      time = 'Boa noite';
    }

    if (faseLogin === 1) {
      saudacao = time + '!';
    }
    if (faseLogin === 2) {
      saudacao = time + ` ${nomeUsuario}, tudo bem? `;
    }
    return saudacao;
  };

  handleSenhaChange = (e) => {
    this.setState({ error: '', senha: e.target.value, empresaSelecionada: '' });
  };

  carregarEmpresas = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { email } = this.state;

    if (!email) {
      this.setState({ error: 'Preencha o e-mail para continuar' });
    } else {
      try {
        const retorno = await api.post('/v1/accounts/empresas', {
          username: email,
        });
        //

        if (!retorno) {
          this.setState({ error: retorno.data.data.error });
          //this.props.history.push('/');
        } else {
          const _data = retorno.data.data;
          if (!_data || _data.length <= 0) {
            this.setState({
              error: 'E-mail não cadastrado/sem permissão para acesso.',
              mostrarEmpresas: 'false',
              ultimopesquisado: '',
              empresas: [],
            });
          } else {
            const empresas = _data.map((item) => {
              return {
                value: item.EMP_ID,
                label: item.EMP_NOME,
                ...item
              };
            });

            this.setState({
              error: '',
              ultimopesquisado: '',
              empresas,
              mostrarEmpresas: 'true',
              nomeUsuario: retorno.data.data[0].USR_NOME,
              faseLogin: 2,
            });
          }
          //
        }
      } catch (err) {
        // let errorStatus;
        // if (!err.response) {
        //   // network error
        //   errorStatus = err;
        // } else {
        //   errorStatus = err.response.data.message;
        // }
        this.setState({
          error: 'E-mail não cadastrado/sem permissão para acesso.',
        });
      }
    }
    this.setState({ loading: false });
  };

  render() {
    const { error, mostrarEmpresas, empresas, loading } = this.state;

    return (
      <Container>
        <LateralEsquerda>
          <img
            src={saibdirectlogo}
            alt="Logo SaibDirect"
            height={105}
            width={580}
          />
          <h5> {this.saudacaoLogin()} </h5>
        </LateralEsquerda>
        <LateralDireita>
          <LoginForm>
            <img src={saibweb} alt="Logo SaibWeb" width={210} />
            <Form onSubmit={this.handleSubmit}>
              <input
                id="email"
                type="email"
                placeholder="E-mail"
                onChange={this.handleUsuarioChange}
                autoComplete="off"
                onBlur={this.carregarEmpresas}
                style={{
                  textTransform: 'lowercase',
                }}
              />
              <input
                id="senha"
                senha="email"
                type="password"
                placeholder="Senha"
                onChange={this.handleSenhaChange}
                autoComplete="off"
              />

              {mostrarEmpresas === 'true' && (
                <DivSelect>
                  <Select
                    placeholder="Selecione uma empresa"
                    onChange={this.handleEmpresas}
                    options={empresas}
                    styles={colourStyles}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: '#8e44ad',
                      },
                    })}
                  />
                </DivSelect>
              )}

              <SubmitButton
                style={{ height: '45px', marginTop: '10px', width: '100%' }}
                loading={loading.toString()}
              >
                {loading ? (
                  <FaSpinner color="#fff" size={14} />
                ) : (
                  <FaKey color="#FFF" size={14} />
                )}
                <span>Login</span>
              </SubmitButton>
              {this.state.error && <p error={error}>{this.state.error}</p>}
            </Form>
          </LoginForm>
        </LateralDireita>
      </Container>
    );
  }
}
export default withRouter(Login);
// export default connect()(Login);
